import type { StackAppearance } from '@unifyapps/defs/blocks/Stack/types';
import _isString from 'lodash/isString';

export const getDirection = (appearance: StackAppearance | undefined) => {
  if (appearance?.reverseOrder) {
    return appearance.direction === 'row' ? 'row-reverse' : 'column-reverse';
  }
  return appearance?.direction;
};

export const getImageUrl = (image: unknown) => {
  if (!_isString(image)) {
    return undefined;
  }

  if (image.startsWith('url(') && image.endsWith(')')) {
    // Extract and return the URL inside the parentheses
    return image.slice(5, -2);
  }
  return image;
};
